<div *ngIf="data" class="summary clearfix">
  <div class="clearfix">
    <div class="data-column big">
      <div class="title">{{'invoice.invoiceable-non-adjective'|translate}}</div>
      <div class="value">{{data.invoiceable.receiptCount}} {{'production.receipts'|translate|lowercase}}</div>
      <div class="value secondair">{{data.invoiceable.amount | float:2}} m<sup>3</sup></div>
    </div>
    <div class="data-column big">
      <div class="title">{{'entity.invoices'|translate}}</div>
      <div class="value">{{data.totals.count}}</div>
      <div class="value secondair">&euro; {{data.totals.totalPrice|float:2}}</div>
    </div>
    <div class="data-column big">
      <div class="title">{{'entity.paid'|translate}}</div>
      <div class="value">{{data.paid.count}}</div>
      <div class="value secondair">&euro; {{data.paid.totalPrice|float:2}}</div>
    </div>
    <div class="data-column big">
      <div class="title">{{'entity.outstanding'|translate}}</div>
      <div class="value">{{data.outstanding.count}}</div>
      <div class="value secondair">&euro; {{data.outstanding.totalPrice|float:2}}</div>
    </div>
    <div class="data-column big">
      <div class="title">{{'ui.lagging-behind'|translate}}</div>
      <div class="value">{{data.overdue.count}}</div>
      <div class="value secondair">&euro; {{data.overdue.totalPrice|float:2}}</div>
    </div>
  </div>
  <div class="actions">
    <button type="button" class="btn btn-sm btn-link mt-1 ps-0" (click)="toInvoiceable()">
      {{'ui.go-to'|translate }} {{'invoice.invoiceable'|translate}} {{'menu.production'|translate|lowercase}}{{'production.receipts'|translate|lowercase}}
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>
